import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=183f8880&scoped=true&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=183f8880&prod&scoped=true&lang=css&"
import style1 from "./Conversation.vue?vue&type=style&index=1&id=183f8880&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f8880",
  null
  
)

export default component.exports